import { useId } from "react";
import { cn } from "@/lib/utils";

interface AISparklesProps {
  className?: string;
}

export function AISparkles({ className }: AISparklesProps) {
  const gradientId = `ai-sparkle-${useId().replace(/:/g, "")}`;

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-4 w-4", className)}
      fill={`url(#${gradientId})`}
      stroke="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#342799" />
          <stop offset="50%" stopColor="#A242A2" />
          <stop offset="100%" stopColor="#FF534C" />
        </linearGradient>
      </defs>
      <path d="M12 2.5a1 1 0 0 1 .95.69l1.7 5.16a2 2 0 0 0 1.27 1.27l5.16 1.7a1 1 0 0 1 0 1.9l-5.16 1.7a2 2 0 0 0-1.27 1.27l-1.7 5.16a1 1 0 0 1-1.9 0l-1.7-5.16a2 2 0 0 0-1.27-1.27l-5.16-1.7a1 1 0 0 1 0-1.9l5.16-1.7a2 2 0 0 0 1.27-1.27l1.7-5.16A1 1 0 0 1 12 2.5z" />
    </svg>
  );
}
